import {
  batchDetailSchema,
  batchRunSchema,
  batchSummarySchema,
  bulkCommitRequestSchema,
  bulkCommitResponseSchema,
  bulkPreflightRequestSchema,
  bulkPreflightResponseSchema,
  listBatchesResponseSchema,
  listExtensionBatchesRequestSchema,
  listExtensionBatchesResponseSchema,
  readBatchRunRequestSchema,
  resolveUncertainRequestSchema,
  resolveUncertainResponseSchema,
  startBatchRunRequestSchema,
  stopBatchRunRequestSchema,
} from "@reactive-resume/schema";
import { createZodDto } from "nestjs-zod/dto";

export class BulkPreflightRequestDto extends createZodDto(bulkPreflightRequestSchema) {}
export class BulkPreflightResponseDto extends createZodDto(bulkPreflightResponseSchema) {}
export class BulkCommitRequestDto extends createZodDto(bulkCommitRequestSchema) {}
export class BulkCommitResponseDto extends createZodDto(bulkCommitResponseSchema) {}
export class BatchSummaryDto extends createZodDto(batchSummarySchema) {}
export class BatchDetailDto extends createZodDto(batchDetailSchema) {}
export class ListBatchesResponseDto extends createZodDto(listBatchesResponseSchema) {}
export class ListExtensionBatchesRequestDto extends createZodDto(
  listExtensionBatchesRequestSchema,
) {}
export class ListExtensionBatchesResponseDto extends createZodDto(
  listExtensionBatchesResponseSchema,
) {}
export class StartBatchRunRequestDto extends createZodDto(startBatchRunRequestSchema) {}
export class StopBatchRunRequestDto extends createZodDto(stopBatchRunRequestSchema) {}
export class ReadBatchRunRequestDto extends createZodDto(readBatchRunRequestSchema) {}
export class BatchRunDto extends createZodDto(batchRunSchema) {}
export class ResolveUncertainRequestDto extends createZodDto(resolveUncertainRequestSchema) {}
export class ResolveUncertainResponseDto extends createZodDto(resolveUncertainResponseSchema) {}

export type {
  BatchDetail,
  BatchRun,
  BatchSummary,
  BulkAction,
  BulkCommitRequest,
  BulkCommitResponse,
  BulkPreflightRequest,
  BulkPreflightResponse,
  ResolveUncertainRequest,
  ResolveUncertainResponse,
} from "@reactive-resume/schema";
export {
  applyBatchItemStatusSchema,
  applyBatchRunStatusSchema,
  applyBatchStatusSchema,
  batchCountsSchema,
  batchDetailItemSchema,
  batchDetailSchema,
  batchRunSchema,
  batchSummarySchema,
  bulkActionSchema,
  bulkCommitRequestSchema,
  bulkCommitResponseSchema,
  bulkItemClassificationSchema,
  bulkItemOutcomeSchema,
  bulkPreflightItemSchema,
  bulkPreflightRequestSchema,
  bulkPreflightResponseSchema,
  bulkResultItemSchema,
  bulkTotalsSchema,
  listBatchesResponseSchema,
  listExtensionBatchesRequestSchema,
  listExtensionBatchesResponseSchema,
  quotaSpendingBulkActionSchema,
  readBatchRunRequestSchema,
  resolveUncertainRequestSchema,
  resolveUncertainResponseSchema,
  startBatchRunRequestSchema,
  stopBatchRunRequestSchema,
  uncertaintyResolutionSchema,
} from "@reactive-resume/schema";
